import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';

const ConfirmDeleteModal = ({ open, handleClose, handleConfirm, peekgroupName }) => {
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = () => {
    if (inputValue === peekgroupName) {
      handleConfirm();
      setInputValue('');
      handleClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Delete PEEKgroup</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Are you sure you want to delete <strong>p/{peekgroupName}</strong> PEEKgroup? 
        </Typography>
        <Typography variant="body2" color="secondary" gutterBottom>
          Please type <strong>{peekgroupName}</strong> to confirm.
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          fullWidth
          label="PEEKgroup Name"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="secondary"
          variant="contained"
          disabled={inputValue !== peekgroupName}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
